import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

type ReturnProps = [
  boolean, // if the clipboard is available in the browser
  (payload: string) => Promise<void>, // copy function
  () => Promise<string>, // paste function
]

export const useClipboard = (): ReturnProps => {
  const { t } = useTranslation()
  const [hasClipboard, setHasClipboard] = useState(false)
  useEffect(() => {
    setHasClipboard(!!navigator.clipboard)
  }, [])
  const copyToClipboard = async (payload: string) =>
    hasClipboard ? navigator.clipboard.writeText(payload) : Promise.reject(t('admin.clipboard.noClipboard'))

  const pasteFromClipboard = async (): Promise<string> =>
    hasClipboard ? navigator.clipboard.readText() : Promise.reject(t('admin.clipboard.noClipboard'))

  return [hasClipboard, copyToClipboard, pasteFromClipboard]
}
